const AUTO_LOGIN = "app/auth/AUTO_LOGIN";
const GET_DEVICES = "app/auth/GET_DEVICES";
const SET_DEVICES = "app/auth/SET_DEVICES";
const LOGIN_SUCCESS = "app/auth/LOGIN_SUCCESS";
const LOGIN_ERROR = "app/auth/LOGIN_ERROR";
const RESET_STATE = "app/auth/RESET_STATE";
const ADD_NOTIFICATIONS = "app/auth/ADD_NOTIFICATIONS";
const EDIT_USER = "app/auth/EDIT_USER";
const SET_USER_INFO = "app/auth/SET_USER_INFO";
const EDIT_DEVICE = "app/auth/EDIT_DEVICE";
const SET_DEVICE_INFO = "app/auth/SET_DEVICE_INFO";
const UPDATE_ACCOUNT_TYPE = "app/auth/UPDATE_ACCOUNT_TYPE";
const COLD_RESET = "app/auth/COLD_RESET";
const FACTORY_RESET = "app/auth/FACTORY_RESET";
const REGISTER_DEVICE = "app/auth/REGISTER_DEVICE";
const UPDATE_FIRMWARE = "app/auth/UPDATE_FIRMWARE";
const GET_WEATHER = "app/auth/GET_WEATHER";
const SET_WEATHER = "app/auth/SET_WEATHER";
const SEND_MESSAGE = "app/auth/SEND_MESSAGE";

export {
  AUTO_LOGIN,
  GET_DEVICES,
  SET_DEVICES,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  RESET_STATE,
  ADD_NOTIFICATIONS,
  EDIT_USER,
  SET_USER_INFO,
  SET_DEVICE_INFO,
  EDIT_DEVICE,
  UPDATE_ACCOUNT_TYPE,
  COLD_RESET,
  FACTORY_RESET,
  REGISTER_DEVICE,
  UPDATE_FIRMWARE,
  GET_WEATHER,
  SET_WEATHER,
  SEND_MESSAGE,
};
